import React, { useState, useRef } from 'react';

import angleDown from '../assets/images/icons/angle-down.svg';

const CustomCombobox = ({placeholder, currentValue, options, onSelect, isCentered, isTinyText, isValidated, error, isStatusDisplayed, customStyles,  }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(currentValue ?? null);
  const comboBoxRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (value) => {
    onSelect ? onSelect(value) : setSelectedValue(value);
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (comboBoxRef.current && !comboBoxRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const comboClassName = `custom-combobox ${isCentered ? 'centered-combo-text' : ''} ${isStatusDisplayed && isValidated ? (error ? "custom-combobox-error" : "custom-combobox-success") : "" }`;

  return (
    <div ref={comboBoxRef}
      className={comboClassName}
      style={{ ...customStyles }}>
      <div className="selected-value" onClick={handleToggle}>
        <p className={isTinyText ? 'tiny-text' : ''}>{currentValue || placeholder}</p>
        <img src={angleDown} className='dropdown-icon'></img>
      </div>
      {isOpen && (
        <ul className="options-list">
          {options.map((option) => (
            <li key={option} onClick={() => handleSelect(option)}
              className={option === selectedValue ? 'selected' : ''}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomCombobox;